import { prefetchedFolderIds } from './prefetchedFolderIds';

export function wasFolderPrefetched(folderId: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (7,12): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    // @ts-expect-error
    return prefetchedFolderIds[folderId];
}
